import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { Milestone } from 'jobs/Job'
import MilestonesViewModel from '../MilestonesViewModel'
import Radio from 'components/Radio'
import styles from './MilestoneItem.sass'

interface Props {
  vm: MilestonesViewModel
  milestone: Milestone
  isLast: boolean
  isCardLayout?: boolean
}

export default observer(function MilestoneItem({
  milestone,
  isLast,
  vm,
  isCardLayout,
}: Props) {
  const completedTasks = milestone.tasks.filter((x) => x.completed).length
  const totalTasks = milestone.tasks.length
  const isSelected = milestone === vm.milestone
  const suffix = isCardLayout ? 'new' : 'classic'

  return (
    <a
      className={cx(styles.root, {
        [styles.last]: isLast,
      })}
      data-test={`milestone-item-${milestone.id}-${suffix}`}
      onClick={() => vm.selectMilestone(milestone)}
    >
      <Radio selected={isSelected} completed={milestone.completed} />
      <div className={styles.info}>
        <div className={styles.title} title={milestone.title}>
          {milestone.title}
          <span className={styles.progress}>
            {completedTasks} of {totalTasks} tasks completed
          </span>
        </div>
        {milestone.description && (
          <div className={styles.description} title={milestone.description}>
            {milestone.description}
          </div>
        )}
      </div>
    </a>
  )
})
